<!--
* 组件名 : 书籍列表
* 开发者 : JY
*
* 参数:
*   content     { String } -  书籍数据
* 事件: null
*
*
-->

<template>
  <section class="article-lists">
    <div class="list-content" v-html="content" ref="listContent" />
    <div class="d-flex justify-content-center">
      <v-btn class="page-arrow" @click.native="read_more($event)"
        ><span>{{ btnText }}</span
        ><v-icon>expand_more</v-icon></v-btn
      >
    </div>
  </section>
</template>
<script>
import { timeout } from "utils/util";

export default {
  name: "article-lists",
  props: {
    content: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isUnf: false,
      btnText: this.$TL.expandAll,
    };
  },
  mounted() {
    this.preset_list_height();
  },
  methods: {
    /**
     * 预设列表高度
     */
    preset_list_height() {
      $(this.$refs.listContent).map((i, item) => {
        let $ul = $(item).children(".dir");
        $ul
          .attr("v-height", $ul.outerHeight())
          .css("height", `${$ul.outerHeight()}px`);
        timeout(200).then(() => $ul.addClass("sec"));
      });
    },
    /**
     * 展开收起操作
     */
    read_more(ev) {
      let $btn = $(ev.currentTarget);
      let $ul = $btn.closest(".article-lists").find(".dir");
      if (this.isUnf) {
        this.btnText = this.$TL.expandAll;
        $btn.closest(".article-lists").removeClass("open");

        $ul.velocity({ height: Number($ul.attr("v-height")) });
        this.isUnf = false;
      } else {
        this.btnText = this.$TL.packUp;
        $btn.closest(".article-lists").addClass("open");

        $ul.velocity({ height: $ul.get(0).scrollHeight });
        this.isUnf = true;
      }
    },
  },
};
</script>
<style lang="scss">
.article-lists {
  &.open {
    .page-arrow {
      margin-top: 24px;
      i {
        transform: rotate(180deg);
      }
    }
  }
  ul.dir {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;

    &.sec {
      li {
        display: block !important;
      }
    }

    li {
      width: 50%;
      margin-bottom: 24px;

      &:nth-of-type(n + 21) {
        display: none;
      }
    }
  }

  .page-arrow {
    span,
    i {
      color: $color-chapter-title;
    }
  }
}
</style>
